import isEmpty from 'validator/lib/isEmpty';

const setProfileSchema = {
  firstName: {
    type: String,
    required: true,
    validate: {
      message: 'setProfileSchema.no-firstname',
      validator: value => !isEmpty(value),
    },
  },
  lastName: {
    type: String,
    required: true,
    validate: {
      message: 'setProfileSchema.no-lastname',
      validator: value => !isEmpty(value),
    },
  },
  nickname: {
    type: String,
    required: true,
    validate: {
      message: 'setProfileSchema.no-nickname',
      validator: value => !isEmpty(value),
    },
  },
  mobileNumber: {
    type: String,
    required: true,
    validate: {
      message: 'setProfileSchema.no-phonenumber',
      validator: value => /^\+[0-9]{5,}$/.test(value),
    },
  },
  language: {
    type: String,
    required: false,
  },
};

export default setProfileSchema;



// WEBPACK FOOTER //
// ./src/schemas/setProfile.js